import React, { useEffect, useState } from 'react';
// import { PencilIcon, ChevronDownIcon, LockClosedIcon, LockOpenIcon } from '@heroicons/react/24/outline';

import { useMedia } from 'react-use';
import { fromRole, getDateString, getSbStatusColorString, getSbStatusString, getUserBgColorsRandom, getUserColorsRandom, humanize, isExpired, ProjectModel, SbStatusMaster, SubmissionBoardModel } from './SbModel';
import submissionBoardService from '../../services/SubmissionBoardService';
import { showToast } from '../../shared/Toast';
import Button from './Button';
import { CircleUserRoundIcon, DotIcon, LockIcon, LockOpenIcon, PenLineIcon } from 'lucide-react';
import UserIcon from './UserIcon';
import { useIsMobile } from './useIsMobile';

export interface SbDetailCardProps {
  project: ProjectModel;
  submissionBoardModel: any;
  fromScreen: string;
  indexRow: number;
  refreshSubmissionBoard?: () => void;
  editSb: (index: number) => void;
  submitForReview?: () => void;
  isSbClosed?: boolean;
  sbCreatorName?: string;
}
export default function SbDetailCard({
  project,
  submissionBoardModel,
  fromScreen,
  indexRow,
  refreshSubmissionBoard,
  editSb,
  submitForReview,
  isSbClosed,
  sbCreatorName,
}: SbDetailCardProps) {
  const isMobile = useIsMobile(); // Hook is used here
  const isTop = false;
  // const isMobileScreen = useMedia('(max-width: 1024px)', false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isSbLocked, setIsSbLocked] = useState(false);
  const [selectedSubmissionBoard, setSelectedSubmissionBoard] =
    useState<SubmissionBoardModel | null>(null);

  // Helper function to get text color class
  const getStatusTextColorClass = (status: string) => {
    const colorString = getSbStatusColorString(status);
    switch (colorString) {
      case 'green':
        return 'text-green-600';
      case 'blue':
        return 'text-blue-600';
      case 'pink':
        return 'text-pink-600';
      case 'sky-blue':
        return 'text-sky-600';
      default:
        return 'text-gray-600';
    }
  };

    const handleLockSb = async (sb_status: string) => {
      if (!selectedSubmissionBoard) return;
      try {
        await submissionBoardService.updateStatusSubmissionBoard(project, selectedSubmissionBoard, {
          sb_status: sb_status,
        });
        if (sb_status == SbStatusMaster.open) {
          showToast('Successfully unlocked ' + submissionBoardModel.title, 'success');
          setIsSbLocked(false);
        } else if (sb_status == SbStatusMaster.locked) {
          showToast('Successfully locked ' + submissionBoardModel.title, 'success');
          setIsSbLocked(true);
        }
  
        if (refreshSubmissionBoard) {
          refreshSubmissionBoard();
        }
      } catch (error) {
        console.error('Failed to lock SB:', error);
        showToast('Failed to lock ' + submissionBoardModel.title, 'danger');
      }
    };
    useEffect(() => {
    if (
      submissionBoardModel.sb_status == SbStatusMaster.expired ||
      submissionBoardModel.sb_status == SbStatusMaster.locked ||
      isExpired(selectedSubmissionBoard?.expire_at) 
    ) {
      setIsSbLocked(true);
    } else {
      setIsSbLocked(false);
    }
    setSelectedSubmissionBoard(submissionBoardModel);
  }, [submissionBoardModel]);
  const handleTap = (e) => {
    e.stopPropagation();
    if (isMobile) {
      setIsDropdownOpen((prev) => !prev);
    }
  };

  return (
    <div className="pb-1 bg-white">
      {selectedSubmissionBoard != null && (
        <div className="bg-gray-100 border border-gray-300 rounded-lg flex flex-col sm:flex-row">
          {(fromScreen == fromRole.SB_CREATOR || fromScreen == fromRole.RECIPIENT) && (
            <div className="flex-1 py-4 px-1 lg:px-1  border-b sm:border-r border-gray-200 text-center">
              <div className="text-xs font-medium text-gray-700">Recipients</div>
              {selectedSubmissionBoard.recipients &&
              selectedSubmissionBoard.recipients.length > 0 ? (
                <div className="relative">
                  {/* Dropdown Trigger */}
                  <div
                    className="flex items-center justify-center px-3"
                    onMouseEnter={() =>{
                      if (!isMobile) {
                        setIsDropdownOpen(true);
                      }
                   }}
                    onMouseLeave={() => {
                      if (!isMobile) {

                      setIsDropdownOpen(false);
                      }
                    }}
                    onClick={isMobile ? handleTap : undefined}
                  >
                    <div className="flex items-center gap-2 text-lg font-medium text-gray-900">
                      {/*<div className="w-6 h-6 rounded-full overflow-hidden">
                        <UserIcon
                          imageUrl={selectedSubmissionBoard.recipients[0].imageUrl}
                          name={selectedSubmissionBoard.recipients[0].name}
                          index={0}
                        />
                         <img
                          className="w-full h-full object-cover"
                          src={selectedSubmissionBoard.recipients[0].imageUrl}
                          alt={selectedSubmissionBoard.recipients[0].name}
                        /> 
                      </div>*/}
                      <span className="truncate w-32">
                        {selectedSubmissionBoard.recipients[0].name &&
                        selectedSubmissionBoard.recipients[0].name != ''
                          ? selectedSubmissionBoard.recipients[0].name
                          : selectedSubmissionBoard.recipients[0].email}
                      </span>
                      <span className="">
                        {selectedSubmissionBoard.recipients.length > 1
                          ? `(+${selectedSubmissionBoard.recipients.length - 1})`
                          : ''}
                      </span>
                    </div>
                  </div>

                  {/* Dropdown Content */}
                  {isDropdownOpen && (
                    <div
                      className={
                        'sm:mt-2 flex flex-col bg-gray-50 border border-gray-200 rounded-lg shadow-xl-0-19-40-8 z-20 pt-10 pb-7 px-5 ' +
                        (isMobile
                          ? ' bottom-auto left-0 top-0 right-0 fixed '
                          : (isTop ? ' bottom-full ' : ' top-full ') +
                            ' absolute left transform   ')
                      }
                    >
                      <div className="absolute top-0 left-1/2 transform  -mt-3">
                        <svg
                          width="25"
                          height="16"
                          viewBox="0 0 25 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10.9881 0.745742C11.7857 -0.175182 13.2143 -0.17518 14.0119 0.745743L23.9235 12.1907C25.0452 13.486 24.1251 15.5 22.4116 15.5H2.58838C0.874875 15.5 -0.0452271 13.486 1.07652 12.1907L10.9881 0.745742Z"
                            fill="#F9FAFB"
                          />
                        </svg>
                      </div>
                      {/* Heading */}
                      <div className="flex items-center justify-center gap-1 text-sm font-semibold text-gray-800">
                        All Recipients:
                      </div>
                      <hr className="mt-4 mb-4" />
                      <div className="flex flex-col items-start truncate justify-start gap-2-1">
                        {selectedSubmissionBoard.recipients.map((user, index) => (
                          <div
                            key={index}
                            className="px-5 text-sm flex w-full flex-row items-center truncate justify-start gap-2-1"
                          >
                            <div className="w-7 h-7 items-center justify-center ">
                              <div className="w-7 h-7 rounded-full bg-gray-200 flex items-center justify-center text-xs font-medium overflow-hidden">
                                <UserIcon imageUrl={user.imageUrl} name={user.name} index={index} />
                              </div>
                            </div>
                            <div className="break-words overflow-hidden text-sm font-normal text-black truncate">
                              {user.name && user.name != '' ? user.name : user.email}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div className="text-xl font-medium leading-none">No recipients added</div>
              )}
            </div>
          )}
          {/* cooridnator name*/}
          {fromScreen == fromRole.SB_PERFORMER && (
            <div className="flex-1 py-4 px-1 lg:px-1  border-r border-gray-200 text-center">
              <div className="text-xs font-normal">Coordinator</div>
              <div className="text-lg font-medium leading-none">{sbCreatorName ?? ''}</div>
            </div>
          )}
          {/* Created at Section */}
          <div className="flex-1 py-4 px-1 lg:px-1  border-b sm:border-r border-gray-200 text-center">
            <div className="text-xs font-medium text-gray-700">Created at</div>
            <div className="text-lg font-medium text-gray-900">
              {getDateString(selectedSubmissionBoard?.created_at, 'PP')}
            </div>
          </div>
          {/* Expire at Section */}
          <div className="flex-1 py-4 px-1 lg:px-1  border-b sm:border-r border-gray-200 text-center">
            <div className="text-xs font-medium text-gray-700">Expire at</div>
            <div
              className={
                'text-lg font-medium text-gray-900' +
                (isExpired(selectedSubmissionBoard?.expire_at) ? ' text-red-500 ' : '')
              }
            >
              {getDateString(selectedSubmissionBoard?.expire_at, 'PP')}
            </div>
          </div>
          {/* Status Section */}
          <div className="flex-1 py-4 px-1 lg:px-1  md:border-r border-gray-200 text-center">
            <div className="text-xs font-medium text-gray-700">Status</div>
            <div className={`text-lg font-medium capitalize flex flex-row justify-center items-center gap-2-1 ${getStatusTextColorClass(isExpired(selectedSubmissionBoard.expire_at) ? 'expired' : selectedSubmissionBoard.sb_status)}`}
              style={{
                padding: 0,
                border: 0
              }}>
              <div className={ 'rounded-full w-2 h-2 chip bg-' + getSbStatusColorString(isExpired(selectedSubmissionBoard.expire_at) ? 'expired' : selectedSubmissionBoard.sb_status)} 
              style={{
                padding: 0,
                border: 0
              }}>
                {/* <DotIcon className='w-4 h-4' strokeWidth={1.5}/> */}
              </div>
              {getSbStatusString(selectedSubmissionBoard.sb_status)}
              {/* {humanize(selectedSubmissionBoard.sb_status ?? '') === SbStatusMaster.pending_review
                ? getSbStatusString(SbStatusMaster.pending_review)
                : humanize(selectedSubmissionBoard.sb_status ?? '') === SbStatusMaster.open
                ? getSbStatusString(SbStatusMaster.open)
                : humanize(selectedSubmissionBoard.sb_status ?? '')} */}
            </div>
          </div>
          {/* Edit Button Section */}
          {/* {fromScreen === fromRole.SB_CREATOR && (
            <div className="flex py-4 px-1 lg:px-1 border-b md:border-b-0 border-gray-200 text-center">
              <div className="flex flex-col py-1 px-2">
                <div className="w-full">
                  <div className="gap-2 flex flex-wrap justify-center">
                    <Button
                      id={'edit_sb_btn_id_' + indexRow}
                      variant="secondary"
                      btn_size="small"
                      icon_position="hor"
                      onClick={() => {
                        if (editSb) {
                          editSb(indexRow);
                        }
                      }}
                    >
                      <div className="w-6 h-6 p-3px flex items-center justify-center">
                        <PenLineIcon className="w-4-2 h-4-2" aria-hidden="true" />
                      </div>
                      {isSbLocked ? 'Edit' : ''}
                    </Button>
                    {!isSbLocked && (
                      <Button
                        id={'lock_sb_btn_id_' + indexRow}
                        variant="secondary"
                        btn_size="small"
                        icon_position="hor"
                        onClick={() => {
                          handleLockSb(SbStatusMaster.locked);
                        }}
                      >
                        <div className="w-6 h-6 p-3px flex items-center justify-center">
                          <LockOpenIcon className="w-4-2 h-4-2" aria-hidden="true" />
                        </div>
                      </Button>
                    )}
                    {isSbLocked && (
                      <Button
                        id={'unlock_sb_btn_id_' + indexRow}
                        variant="secondary"
                        btn_size="small"
                        icon_position="hor"
                        className="chip blue"
                        onClick={() => {
                          handleLockSb(SbStatusMaster.open);
                        }}
                      >
                        <div className="w-6 h-6 p-3px flex items-center justify-center">
                          <LockIcon className="w-4-2 h-4-2" aria-hidden="true" />
                        </div>
                        {isSbLocked ? 'Unlock' : ''}
                      </Button>
                    )}{' '}
                    {!isSbLocked &&
                      selectedSubmissionBoard != null &&
                      selectedSubmissionBoard.recipients &&
                      selectedSubmissionBoard.recipients.length > 0 &&
                      !isSbClosed && (
                        <Button
                          id={'submit_review_sb_btn_id_' + indexRow}
                          variant="primary"
                          btn_size="small"
                          icon_position="hor"
                          onClick={() => {
                            if (submitForReview) {
                              submitForReview();
                            }
                          }}
                        >
                          <div className="w-6 h-6 p-3px flex items-center justify-center">
                            <LockIcon className="w-4-2 h-4-2" aria-hidden="true" />
                          </div>
                          <span>Submit Board</span>
                        </Button>
                        // <button
                        //   id={'submit_review_sb_btn_id_' + indexRow}
                        //   onClick={() => {
                        //     if (submitForReview) {
                        //       submitForReview();
                        //     }
                        //   }}
                        //   type="button"
                        //   className="flex-3 inline-flex items-center px-4 py-2 border border-transparent text-sm font-semibold rounded-md shadow-sm text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                        // >
                        //   Submit Board
                        // </button>
                      )}
                  </div>
                </div>
              </div>
            </div>
          )} */}
        </div>
      )}
    </div>
  );
}
